import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-ordre-nav',
    templateUrl: './ordre-nav.component.html',
    styleUrls: ['./ordre-nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrdreNavComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
